import { MinuteInput, StyledMaxWidth } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';
import { AppointmentFormController } from '../AppointmentForm.types';

import { useSyncEndTime } from './EstimatedDurationField.hooks';

type EstimatedDurationFieldProps = Pick<AppointmentFormController, 'register' | 'setValue' | 'watch'>;

export const EstimatedDurationField = (props: EstimatedDurationFieldProps): JSX.Element => {
   useSyncEndTime(props.setValue, props.watch);

   return (
      <StyledMaxWidth maxWidth={146}>
         <MinuteInput
            controller={props.register('estimatedDuration', { required: true })}
            label={appointmentsTranslationKeys.create.form.estimatedDuration}
            testId={'estimatedDuration'}
         />
      </StyledMaxWidth>
   );
};
